"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'autocomplete.triggers.suggestions': 'Available items',
    'autocomplete.triggers.noResults': 'No matching items found',
    'autocomplete.triggers.stylesPlaceholder': 'Type / to search styles...',
    'autocomplete.triggers.projectsPlaceholder': 'Type # to search projects...',
    'autocomplete.triggers.knowledgePlaceholder': 'Type @ to search knowledge...',
    'autocomplete.triggers.loading': 'Loading...',
    'autocomplete.triggers.error': 'Error loading suggestions',
};
